import OnboardingService from 'admin/services/api/OnboardingService';
import OptimizelyStore from 'admin/stores/OptimizelyStore';
import { hotspotAreas } from './onboardingData';

class OnboardingStore {
  defaultState = {
    tasks: {
      completed: {},
      locked: {}
    },
    hotspots: {
      completed: {}
    }
  };

  getState(bypassCache) {
    return Promise.resolve()
      .then(() => {
        if (this.state && !bypassCache) {
          return this.state;
        }

        if (this.pendingRequest) {
          return this.pendingRequest;
        }

        this.pendingRequest = OnboardingService.getOnboardingData()
          .then(response => this.setState(response.data));
        return this.pendingRequest;
      });
  }

  setState(state) {
    const newState = state.tasks ? state : { ...this.defaultState };
    this.state = newState;
    return this.state;
  }

  isHotspotAreaCompleted(areaId) {
    if (!this.state.hotspots) {
      return false;
    }
    if (!hotspotAreas[areaId]) {
      return false;
    }

    for (let i = 0; i < hotspotAreas[areaId].hotspots.length; i += 1) {
      const id = hotspotAreas[areaId].hotspots[i];
      if (!this.state.hotspots.completed[id]) {
        return false;
      }
    }

    return true;
  }

  dismissHotspot(hotspotId) {
    return OnboardingService.dismissHotspot(hotspotId)
      .then(updatedState => this.setState(updatedState.data))
      .then(() => {
        const areaId = hotspotId.split('.')[0];
        if (this.isHotspotAreaCompleted(areaId)) {
          this.completeTask(hotspotAreas[areaId].taskName);
        }
      });
  }

  completeTask(taskId) {
    return this.getState()
      .then((state) => {
        if (!state.tasks.completed[taskId]) {
          return OnboardingService.updateTask({ taskId, action: 'complete' })
            .then(updatedState => this.setState(updatedState.data));
        }
      });
  }

  unlockTask(taskId) {
    return this.getState()
      .then((state) => {
        if (state.tasks.locked[taskId]) {
          return OnboardingService.updateTask({ taskId, action: 'unlock' })
            .then(updatedState => this.setState(updatedState.data));
        }
      });
  }

  setShowNextStepNotice(sessionKey) {
    const showNextStepNotice = window.sessionStorage.getItem(sessionKey);
    window.sessionStorage.removeItem(sessionKey);
    return showNextStepNotice;
  }

  completeInitialTask(taskId, taskKey) {
    return this.getState().then((state) => {
      OptimizelyStore.trackEvent(taskId);

      if (!state.tasks.completed[taskId]) {
        this.completeTask(taskId);
        window.sessionStorage.setItem(taskKey, true);
      }
    });
  }
}

export default new OnboardingStore();



// WEBPACK FOOTER //
// ./src/app/admin/stores/OnboardingStore/index.js